import * as React from "react";
import KarteInterface from "../../../interfaces/KarteInterface";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import { StudentWithStayInterface } from "../../../interfaces/StudentInterface";
import StudentAiAssistantKarteField from "../StudentAiAssistantKarteField";
import StudentKarteForm from "../StudentKarteForm";
import StudentKarteList from "../StudentKarteList";

interface Props {
  student: StudentWithStayInterface;
  kartes: KarteInterface[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  operator: OperatorInterface | null;
}

const StudentKartes = (props: Props) => {
  return (
    <React.Fragment>
      <StudentKarteForm student={props.student} operator={props.operator} />
      <StudentAiAssistantKarteField student={props.student} />
      <StudentKarteList
        kartes={props.kartes}
        isLoading={props.isLoading}
        isFetchingNextPage={props.isFetchingNextPage}
      />
    </React.Fragment>
  );
};

export default StudentKartes;
